export const GlobalEvents = {
  UserChanged: 'event:UserChanged',
  UserAvailable: 'event:UserAvailable',
  FileUploadError: 'event:FileUploadError',
};



// WEBPACK FOOTER //
// ./src/js/core-utilities/enums/GlobalEvents.js